import type {
  CareTeamGetAllResponse,
  CareTeamSearchParams,
  CreateCareTeam,
  GetCareTeamResponse,
  UpdateCareTeam,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class CareTeamApi {
  public createCareTeam = async (
    careTeam: CreateCareTeam,
  ): Promise<Partial<GetCareTeamResponse>> => {
    const result = await trpcClient.careTeam.create.mutate(careTeam);

    return result;
  };

  public getAllCareTeams = async (
    params: CareTeamSearchParams = {},
  ): Promise<CareTeamGetAllResponse> => {
    const result = await trpcClient.careTeam.getAll.query(params);

    return result;
  };

  public getCareTeam = async (id: string): Promise<GetCareTeamResponse> => {
    const result = await trpcClient.careTeam.getById.query({ id });

    return result;
  };

  public updateCareTeam = async (
    careTeam: UpdateCareTeam,
  ): Promise<Partial<GetCareTeamResponse>> => {
    const result = await trpcClient.careTeam.update.mutate(careTeam);

    return result;
  };
}
